export interface SearchHit {
  companyId: string;
  companyName: string;
  legalGroupCode: string;
  legalGroupText: string;
  town: string;
}

export interface OverviewResponseProperties {
  hits: Array<SearchHit>;
}

interface CompanySearchResponse {
  properties: OverviewResponseProperties;
}

const getCompanySearch = async (
  country: string,
  searchedText: string
): Promise<CompanySearchResponse> => {
  const params = `searchedText=${searchedText}`;
  const url = `${process.env.REACT_APP_BACKEND_URL}/signup/country/${country}/search?${params}`;
  const response = await fetch(url, {
    method: "GET",
    headers: { Accept: "application/json" },
  });
  return response.json();
};

export default getCompanySearch;
